
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqmjLTw6p_4553Sex_45tMXiXDV8mt5aQ_FWSxFVlCfVg3aOcMeta } from "/codebuild/output/src2772137923/src/src/pages/faq.vue?macro=true";
import { default as menu5UcgDp1ao9bQ6LXvgoNUQXnarUGaYbdD98GauOF49FIMeta } from "/codebuild/output/src2772137923/src/src/pages/menu.vue?macro=true";
import { default as index_45Anzp5MOjLNSJ6FSXET7T6x2mPCSkto3bOAG_45unp0oUMeta } from "/codebuild/output/src2772137923/src/src/pages/index.vue?macro=true";
import { default as contactdofMWvg6f2VWYnudWReICr5dsp31KAuKnZnmMENDO2QMeta } from "/codebuild/output/src2772137923/src/src/pages/contact.vue?macro=true";
import { default as tutorial673w3Ny9bKGDhpQiodh40dpcQ4slITP7OvnJgHWsxMYMeta } from "/codebuild/output/src2772137923/src/src/pages/tutorial.vue?macro=true";
import { default as agreementRKAJfGbWbmM0DX4_45iiRMJopOB_45JJIhoU6jhgWqaU0cEMeta } from "/codebuild/output/src2772137923/src/src/pages/agreement.vue?macro=true";
import { default as about_45passWDh5wH50msYYoyEnpZ5JnKSDqP8gYl3Gb37YQ2HlGA8Meta } from "/codebuild/output/src2772137923/src/src/pages/about-pass.vue?macro=true";
import { default as indexxYrCDcXBuRIWGj_45u6u3aMOKbW_45MkLHoll_45xOl8Yq6joMeta } from "/codebuild/output/src2772137923/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93efudT6cEc87lqEuk_GmxTe1_ksgKcc7xouCBzh2kkjUMeta } from "/codebuild/output/src2772137923/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance24p8xPRAVHYjDXY0_45PQkczB1VVtQLGO5S4ytJQIJekcMeta } from "/codebuild/output/src2772137923/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93vRBy4ym5eJFdR6ZqDoXlh0YiR0v0jzsEYfk7HFaMFSAMeta } from "/codebuild/output/src2772137923/src/src/pages/notice/[id].vue?macro=true";
import { default as indexSreC8PmiQi3L5QHCpYO27sXTtkH9OzdDROMyNangJlkMeta } from "/codebuild/output/src2772137923/src/src/pages/coupon/index.vue?macro=true";
import { default as indexazwZGiZYErLxsa8Vngas8Elzed2XB9xuq_qcRUfhWi8Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/index.vue?macro=true";
import { default as indexzroa6XvohQ9r5qhOacFxb4WOCbChCV0oSaWObyJKZBUMeta } from "/codebuild/output/src2772137923/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_938IqDBwXKVWvYUSXFKd_45H2Vywa3w6RtjwenU5Nh2KgtMMeta } from "/codebuild/output/src2772137923/src/src/pages/parking/[id].vue?macro=true";
import { default as indexXWUmG_uvzFZVbf2_7G5LgrxyB8rI3bRk1zXgsT_CiuUMeta } from "/codebuild/output/src2772137923/src/src/pages/history/index.vue?macro=true";
import { default as index8Ds1ev4ZYY9W_EMVJVi6vTceQmSSRNJpn0kQp8vJMLYMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/index.vue?macro=true";
import { default as indexL3ZnngK8UU72KJ9wHtChWJgcf9oWvsj5FKreTIrQmycMeta } from "/codebuild/output/src2772137923/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexD7cZIEMQxnmmrAK9OjLwpm5g_45sf23SYaF0WBF3o6PbAMeta } from "/codebuild/output/src2772137923/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviLNstmyMte1N8a4emPwqL59841wBH969onZO85fJK5n8Meta } from "/codebuild/output/src2772137923/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editP_RTri6O_5bl824IhcptXvi0qQidnPzYy8R0atHu3usMeta } from "/codebuild/output/src2772137923/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementMe2wEoyppmOFvdXrNEyrutQeEA5JIFyWETlcQeZ0macMeta } from "/codebuild/output/src2772137923/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexmx7tzHozikZ9CIAvkbhje2yNjYV_e0W31RLQQ_45jKtdcMeta } from "/codebuild/output/src2772137923/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dr6SviwFY5LVXlD9SqwQvjUCoTSjCugzmHRGo7B7oZAQMeta } from "/codebuild/output/src2772137923/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmXXSOjXpUwgI_6ugs6tzKhBryLCq16JkSld9EV7ygGEcMeta } from "/codebuild/output/src2772137923/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexID1hcueyCkyGTdQtlylA0fAhaV0ur018qK2xvhG6u98Meta } from "/codebuild/output/src2772137923/src/src/pages/card/create/index.vue?macro=true";
import { default as indexjDjUZn9RVKPZdi7OaTb5WtYglemPqHaqy7OGuRBQd0AMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmRchxXHseQvMNpswXNwHN7dadVuoJFgy4UFWXKoReFaYMeta } from "/codebuild/output/src2772137923/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmoAPsI5Gwbqyricd2JnL6kvBg5jVL6zyKVkbiecGRZ_458Meta } from "/codebuild/output/src2772137923/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeaSswpk_26bKpF0_45pXVeiTRUXFdoKs2b2nAMWN6fgTwgMeta } from "/codebuild/output/src2772137923/src/src/pages/membership/complete.vue?macro=true";
import { default as registerdB1Alv5gTlyOVLRdPYi5Cp6oI8qsUP9zSAO_ir5XvX8Meta } from "/codebuild/output/src2772137923/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93OVz0_JOl3O8XmT5Oto9mAo0_4lRI_9P9S941MEFRGPsMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmtIZJNElaKsteO7QgSZWiu8yAXb3L9rRpukQkw49LVWoMeta } from "/codebuild/output/src2772137923/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93uxY3AGbAq99mhvoIgnfEIYnkmhr47ze9YWdQxD01EsgMeta } from "/codebuild/output/src2772137923/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexW5EpdL_OjoV85fWpYz4zBqI3dMrr1yY4P7rTnBZ0VgQMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeo7nS5JONJmMCz76ndeWddJnex6aM1wxrIiW0yAacK0kMeta } from "/codebuild/output/src2772137923/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code4svUKEkFz_452AkMb6RqvVpZtFgsXYJ4pPJ7mxyGDTu_458Meta } from "/codebuild/output/src2772137923/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeMoi6qNXxJJCf9OB_45KyfF8YKFiq4xNqeajY2qNnriXSgMeta } from "/codebuild/output/src2772137923/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register39jkiTMxdlMppqd7zcCGGhXSSiAJNvf1AAp9npsb6YEMeta } from "/codebuild/output/src2772137923/src/src/pages/contact-form/register.vue?macro=true";
import { default as completelE7vjgnPit0fz5QKQHy4tv116yCEkcqgtjjFdtmQSPsMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexGoVj6yCyG6BhuTo1KJ_45ogG3zBNuPHUJkQx4kVOoSvUQMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmRg6O_j7K7HjIdfM1NgshlLLZOrpFRD9qANaS2qDuu2AMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete5bbuIFaUEWkpyjs7p6nlqbfbrk6sjmME_qK0CRWqgNEMeta } from "/codebuild/output/src2772137923/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexuzUYLYeinKdE99Zix5GK4dDJq3MXhklgzdmIUvJ6btkMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93w9F0ByGrdx0_57ZxkUsWf9vaIOkYsyQ7SJERfWUVAtYMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeQYWeKb7_45SFdt_4Zp_45fg9XrKE28dv5GLRhkZDWxdcsZIMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasnEkhUgfFhTOdXHOsOedG_S0M_453ScLttt789T83uYHBUMeta } from "/codebuild/output/src2772137923/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleZO6TO_VEKSbyThxuMqVIfeR3IiqtBBkx3_aO_450hu_45_AMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailJzjivbhvEv2D_jQhKJNUX737ubNbgzIHvDiWH9fnxTwMeta } from "/codebuild/output/src2772137923/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm37nN8iIPxMiXLtTUhV_45f0cOUdnJSsIzWxa0R95G6X18Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentvb_45Z2uo0WIoWNiR3GVFzi4H48joAISl0Awv8CeN5dCkMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhCqThpT1AEKTB_u_45yf23S8o1xeIICqtJikUmlz63daUMeta } from "/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateuJC1MjgYyfPNj4kHaAEG0fzaxOFqy4AskX4Cd3zS0sQMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completevCiomb25m6Rx7B2CQ_7U4nsfb_45r_45kQ9ak80ZNKsfEd4Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codesNV4oc8_nhQQFG7PxR4_vqR0gUbViI8k5NQCmRSBHVIMeta } from "/codebuild/output/src2772137923/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordVuqNghca7I0CxkE0m0ZuRuvr1S3Qox_45iB7JHJesoLbAMeta } from "/codebuild/output/src2772137923/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasaTB3sLQ9JTAbZIvpAPYiAMfQOLwlH0MHhIpS5tkxhjcMeta } from "/codebuild/output/src2772137923/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register__3fqyongqbIQbhf6tobRWUIJltvruXuYphplsOKJu4Meta } from "/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeVYXVH7N3wI15_45gyHLwCCEhU9hMi33axag38nvBD1EpkMeta } from "/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexEFv53bV0M6y0L_45Gb9jJrOyMLP9E9AJd3QuwJnJH1vs0Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexP9ETYrpHJ3m92jUMFukv_452YyN_45hA2R9kIq1C9MyfSh8Meta } from "/codebuild/output/src2772137923/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexDVO7bWfD7RzeYdfbNBA9GKg2kO_QYbelqrwDcYtt6q8Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexsH3VhQxXyPNgG5EyYiv1qfbEtP1A3fQjl9kLp0unlQwMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update4OdTFK_45jzGLlLk3x4_5cJEjSLar9aCSXZnPPIIlqRcsMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete5EWKGVdrH_45Ng_4vfH40nm9udzw2j6I3sQIu4VBCDDRkMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmHXuRLaDT3dTQatzuwd1O8JQu0hZRiNpWZwCYMIfHZjQMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexc_45yQJP_0TtKPPIoKDyc9Pko3wgr5cbzpAUvdrUpP7XYMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completewM63QBSpde0UTh0EyGmgVZYAxGauciDqGyV7f_lDjl4Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatebO_45Mii0BrhnMesA07gseqyNjgLvlfrIHf7oW8ZUEFG8Meta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index4nLAYM4hmsryPbcz7CeXTcHbAhVCbE2TQDxXgPhO9iUMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexCTVJyZPwOlOxdTQf6YRW3wkXSCzFw6DRUg45kiIzCTYMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeLjhQQQXaDG2eeANZmpqLkvcGSpiw_45lBm1os77yDiL9cMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexyQv05dsfflejbAa49YKfjequrFYHHdwgWtAOs0IjolQMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeCPFcArzCxs2xdDVBCnVbPALOHrjTFvJ98XVILo3QmysMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexw90wf9bCUI2iMTMzMyQiOd_NWVzJ5oxAhlTa3i2mxioMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVvdUY8U0Ma6SWelUrv6U2mAGNKXNsC_Gqf2G3aSUuk8Meta } from "/codebuild/output/src2772137923/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexCWBk9mr58RuVvMwKO0xiXx0sJot0ZxbYN4vzfJDLjNcMeta } from "/codebuild/output/src2772137923/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatenOOLZDpu72ixeZBhXDFh_V4Qb8qNAADSsV7PEZvpJPYMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmWQz6SlRWWhnnHrqtAgGp2Yh_45moTKHTQuJkVQF6Wla6EMeta } from "/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu5UcgDp1ao9bQ6LXvgoNUQXnarUGaYbdD98GauOF49FIMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index_45Anzp5MOjLNSJ6FSXET7T6x2mPCSkto3bOAG_45unp0oUMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexSreC8PmiQi3L5QHCpYO27sXTtkH9OzdDROMyNangJlkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexXWUmG_uvzFZVbf2_7G5LgrxyB8rI3bRk1zXgsT_CiuUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexL3ZnngK8UU72KJ9wHtChWJgcf9oWvsj5FKreTIrQmycMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexD7cZIEMQxnmmrAK9OjLwpm5g_45sf23SYaF0WBF3o6PbAMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexID1hcueyCkyGTdQtlylA0fAhaV0ur018qK2xvhG6u98Meta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmRchxXHseQvMNpswXNwHN7dadVuoJFgy4UFWXKoReFaYMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmoAPsI5Gwbqyricd2JnL6kvBg5jVL6zyKVkbiecGRZ_458Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeaSswpk_26bKpF0_45pXVeiTRUXFdoKs2b2nAMWN6fgTwgMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerdB1Alv5gTlyOVLRdPYi5Cp6oI8qsUP9zSAO_ir5XvX8Meta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmtIZJNElaKsteO7QgSZWiu8yAXb3L9rRpukQkw49LVWoMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeo7nS5JONJmMCz76ndeWddJnex6aM1wxrIiW0yAacK0kMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code4svUKEkFz_452AkMb6RqvVpZtFgsXYJ4pPJ7mxyGDTu_458Meta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeMoi6qNXxJJCf9OB_45KyfF8YKFiq4xNqeajY2qNnriXSgMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register39jkiTMxdlMppqd7zcCGGhXSSiAJNvf1AAp9npsb6YEMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmRg6O_j7K7HjIdfM1NgshlLLZOrpFRD9qANaS2qDuu2AMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete5bbuIFaUEWkpyjs7p6nlqbfbrk6sjmME_qK0CRWqgNEMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexuzUYLYeinKdE99Zix5GK4dDJq3MXhklgzdmIUvJ6btkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeQYWeKb7_45SFdt_4Zp_45fg9XrKE28dv5GLRhkZDWxdcsZIMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleZO6TO_VEKSbyThxuMqVIfeR3IiqtBBkx3_aO_450hu_45_AMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailJzjivbhvEv2D_jQhKJNUX737ubNbgzIHvDiWH9fnxTwMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm37nN8iIPxMiXLtTUhV_45f0cOUdnJSsIzWxa0R95G6X18Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentvb_45Z2uo0WIoWNiR3GVFzi4H48joAISl0Awv8CeN5dCkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhCqThpT1AEKTB_u_45yf23S8o1xeIICqtJikUmlz63daUMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completevCiomb25m6Rx7B2CQ_7U4nsfb_45r_45kQ9ak80ZNKsfEd4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codesNV4oc8_nhQQFG7PxR4_vqR0gUbViI8k5NQCmRSBHVIMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordVuqNghca7I0CxkE0m0ZuRuvr1S3Qox_45iB7JHJesoLbAMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register__3fqyongqbIQbhf6tobRWUIJltvruXuYphplsOKJu4Meta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeVYXVH7N3wI15_45gyHLwCCEhU9hMi33axag38nvBD1EpkMeta || {},
    component: () => import("/codebuild/output/src2772137923/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2772137923/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]